/**
 * Created by DynamicDog on 2017-03-30.
 */

import { EmailDialogComponent } from './maildialog.component';
import {EtikettService} from '../services/etikett.service';
import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService {

    constructor(private dialog: MdDialog,private etikettService:EtikettService) { }

    public compose(): void {

        let dialogRef: MdDialogRef<EmailDialogComponent>;

        dialogRef = this.dialog.open(EmailDialogComponent);
//        dialogRef.componentInstance.title = title;
//        dialogRef.componentInstance.message = message;

        dialogRef.afterClosed().subscribe(result => {
            if(result) {
                var data = dialogRef.componentInstance;
                this.etikettService.sendMail(data.from,data.to,data.subject,data.message);
            }
        });;
    }
}



// WEBPACK FOOTER //
// ./app/dialogs/email.service.ts